import Brightness1Icon from '@mui/icons-material/Brightness1';
import * as React from 'react';
import { memo } from 'react';

import { FlightTurnaroundDto } from '../../../../../../../backend';
import { ganttOneMinuteInMilliSeconds } from '../../../gantt.constants';

/**
 * True for multi day occupation where no flight is considered (arr/dep date not today)
 * **/
const shouldShowMultiDayTurnaroundFlightIdentity = (turnaround: FlightTurnaroundDto) =>
    turnaround.multiDaysOccupation && !turnaround.considerArrivalFlight && !turnaround.considerDepartureFlight;

export const TurnaroundData = memo(function TurnaroundData({
    turnaround,
    occupation,
    addTargetBoardingTimesIcon,
}: {
    turnaround: FlightTurnaroundDto;
    occupation: number;
    addTargetBoardingTimesIcon: boolean;
}) {
    const margin = occupation && occupation < 20 * ganttOneMinuteInMilliSeconds ? '1px' : '5px';
    // When both flights are displayed, the registration is displayed once, after the departure flight
    const isRegistrationDisplayedWithDeparture =
        turnaround?.considerDepartureFlight && !!turnaround.departureFlight?.registrationNumber;

    if (shouldShowMultiDayTurnaroundFlightIdentity(turnaround)) {
        const airlineCode = turnaround?.arrivalFlight
            ? turnaround.arrivalFlight.airlineIata || turnaround.arrivalFlight.airlineIcao
            : turnaround?.departureFlight?.airlineIata || turnaround?.departureFlight?.airlineIcao;
        const registrationNumber = turnaround?.arrivalFlight
            ? turnaround.arrivalFlight.registrationNumber
            : turnaround?.departureFlight?.registrationNumber;
        return (
            <>
                {airlineCode}
                {airlineCode && registrationNumber && <>/</>}
                {registrationNumber}
            </>
        );
    }

    // For single day occupation or multi day (dry arr/dep) where flight is considered (arr/dep date is today)
    return (
        <>
            {turnaround?.considerDepartureFlight && turnaround.departureFlight?.tsbt && addTargetBoardingTimesIcon && (
                <Brightness1Icon sx={{ color: '#0096FF', width: '8px', height: '8px', marginRight: margin }} />
            )}
            {turnaround?.considerArrivalFlight && (
                <>
                    {turnaround?.arrivalFlight?.flightNumber && (
                        <>
                            {turnaround?.arrivalFlight
                                ? turnaround.arrivalFlight.airlineIata || turnaround.arrivalFlight.airlineIcao
                                : turnaround?.departureFlight.airlineIata || turnaround?.departureFlight.airlineIcao}
                            {turnaround?.departureFlight?.flightNumber && turnaround?.considerDepartureFlight && (
                                <>&thinsp;</>
                            )}
                        </>
                    )}
                    {turnaround?.arrivalFlight &&
                        (occupation && occupation < 30 * ganttOneMinuteInMilliSeconds ? (
                            <>
                                {turnaround.arrivalFlight.flightNumber?.substring(0, 4) ||
                                    turnaround.arrivalFlight.callsign?.substring(0, 5)}
                            </>
                        ) : (
                            <>{turnaround.arrivalFlight.flightNumber || turnaround.arrivalFlight.callsign}</>
                        ))}
                    {(turnaround?.multiDaysOccupation ||
                        (!!turnaround.departureFlight &&
                            !turnaround.arrivalFlight &&
                            turnaround.considerDepartureFlight)) &&
                        !isRegistrationDisplayedWithDeparture &&
                        `/${turnaround.arrivalFlight?.registrationNumber} `}
                </>
            )}
            {turnaround?.considerArrivalFlight && turnaround?.considerDepartureFlight && <div>{'/'}</div>}
            {turnaround?.considerDepartureFlight && (
                <>
                    {(!turnaround?.arrivalFlight?.flightNumber || !turnaround?.considerArrivalFlight) &&
                        turnaround?.departureFlight?.flightNumber && (
                            <>
                                {turnaround?.arrivalFlight
                                    ? turnaround.arrivalFlight.airlineIata || turnaround.arrivalFlight.airlineIcao
                                    : turnaround?.departureFlight?.airlineIata ||
                                      turnaround?.departureFlight?.airlineIcao}
                            </>
                        )}
                    {turnaround?.departureFlight &&
                        (occupation && occupation < 30 * ganttOneMinuteInMilliSeconds ? (
                            <>
                                {turnaround.departureFlight.flightNumber?.substring(0, 4) ||
                                    turnaround.departureFlight.callsign?.substring(0, 5)}
                            </>
                        ) : (
                            <>{turnaround.departureFlight.flightNumber || turnaround.departureFlight.callsign}</>
                        ))}
                    {(turnaround?.multiDaysOccupation ||
                        (!!turnaround.departureFlight &&
                            !turnaround.arrivalFlight &&
                            turnaround.considerDepartureFlight)) &&
                        turnaround.departureFlight?.registrationNumber &&
                        `/${turnaround.departureFlight.registrationNumber} `}
                </>
            )}
        </>
    );
});
